import { render, staticRenderFns } from "./ManufacturingLogbooksPanel.vue?vue&type=template&id=57312539&scoped=true"
import script from "./ManufacturingLogbooksPanel.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbooksPanel.vue?vue&type=script&lang=js"
import style0 from "./ManufacturingLogbooksPanel.vue?vue&type=style&index=0&id=57312539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57312539",
  null
  
)

export default component.exports